module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-f294e358.png";